module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("SEBASTIAN SE")]), _vm._v(" réveilla avec sa cuillère serrée entre ses doigts. Il leva les yeux, le reste de sa famille, groggy, revenait à elle – y compris les trois frères et sœurs impliqués dans le complot. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Je ne peux même pas faire sem")]), _vm._v("blant d’être surpris qu’elle nous ait tous drogués.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin tourna la tête en direction de Diana, mais s’arrêta à mi-chemin. Au lieu de cela, il se tourna vers Kraven.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— T’es-tu lavé les mains avant de manipuler notre nourriture ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quoi ? demanda Kraven, un morceau d’oignon tombant de sa joue.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Les herbes que tu as coupées pour notre dîner. De toute évidence, Pratchett et toi les avez contaminées, dit Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous nous sommes lavé plusieurs fois les mains, tu...")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pratchett s’interrompit et se lécha les lèvres.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je, quoi ? demanda Diana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Père, nous nous sommes lavé les mains, insista Kraven.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’était une simple erreur, Kraven, et nous avions besoin de repos.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Orwell se leva et s’étira.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Votre mère sera bientôt rentrée. Nettoyez la table et la vaisselle. Je vais me coucher.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leur père quitta la pièce et Ophélia soupira.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il sait que ce n’est pas les garçons.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Qu’est-ce que vous complotez ? demanda Démétrius.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce ne sont pas tes affaires, répondit Diana en fixant le plafond. Je parie qu’il est monté vérifier son sac.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quel sac ? demanda Kraven. Je savais que je m’étais lavé les mains !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— La ferme.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin couvrit la bouche de son frère.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lorsque le bruit étranglé s’évanouit, Kevin le relâcha. Il tourna des yeux chagrinés vers Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mais j’ai été gentil avec toi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai dit de blâmer Pratchett, pas Kraven.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kevin haussa les sourcils.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ils se ressemblent tous pour moi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pratchett ramassa son assiette et alla dans la cuisine d’un pas lourd.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’espère que vous rôtirez tous dans la fosse du dragon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("— DEMETRIUS, POURQUOI")]), _vm._v(" souris-tu ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian trouva son frère dans le salon, souriant, les jambes calées sur un tabouret.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Désolé, mais tu as oublié ta place et conspiré avec l’ennemi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Démétrius ferma les yeux et fredonna.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Imbécile, bougonna Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il entra dans la cuisine et découvrit sa mère, regardant la photo du monstrueux homme à la cape.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quelle image inconvenante ! Comment cela a-t-il pu se passer ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lady Orwell leva l’avis de recherche.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— L’imagination fertile d’un villageois ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Et celle-ci ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lady Orwell lui montra l’image précise.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian leva les yeux vers ceux du même vert, de sa mère qui brillaient d’agacement. Il serra sa main en poing sans se détourner du regard sévère.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Père, le sait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il regarda sa lèvre bouger alors qu’elle se mordait l’intérieur de la joue.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Si vous criez après moi, Père le saura et je m’enfuirai avant que vous lui parliez.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Les yeux de sa mère s’étrécirent, mais Sebastian sut que ce n’était pas suffisant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Et il sait qui a tenté d’assassiner le prince.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oh, merde !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lady Orwell se retourna et sortit précipitamment de la cuisine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian se retrouva choqué, car sa mère jurait rarement. Voyant là une chance de s’échapper, il passa en courant devant son frère qui fronça les sourcils. En chemin vers sa chambre, il frappa à la porte d’Ophélia. Quand il entra en trombe dans sa propre chambre, il attrapa un oreiller, arracha le tissu et se précipita vers son tiroir. Il fourra la taie d’oreiller de vêtements et de livres. Ophélia se tenait à la porte, ses yeux blancs emplis de confusion. Sebastian l’écrasa entre ses bras.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je dois y aller. Père va tout raconter à Mère, je t’aime.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il la dépassa, mais elle saisit son bras.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Père a posé des scellés sur les portes avant et arrière ce matin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Évidemment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il étreignit à nouveau sa sœur et alla à sa fenêtre. Il la déverrouilla et posa son sac de fortune sur le toit avant d’y grimper.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Au revoir, dit-il tandis qu’il refermait la fenêtre derrière lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("À mi-hauteur de la gouttière, sa botte se colla au métal.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Fils de…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il tira de toutes ses forces, mais les défenses de la maison avaient été activées. Il agrippa la gouttière et se baissa afin que sa botte se trouve au niveau de ses yeux. Il s’accrocha d’une main et se servit de l’autre pour la délacer. Puis, enroulant ses bras autour du métal, il sortit son pied. Enfin libre, il se laissa tomber au sol et commença à courir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("— COMMENT EST-CE")]), _vm._v(" arrivé, sire Orwell ? demanda le cordonnier quand Sebastian entra en boitillant dans sa boutique.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Une mésaventure maladroite dont je suis trop embarrassé pour vous en parler, mon bon monsieur. Avez-vous des chaussures à ma pointure ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il s’était cogné les orteils sur de nombreux rochers, il ne voulait pas davantage de blessures.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous savez, sire Orwell, tout le monde possède un pied soit trop grand, soit trop petit, mais les vôtres sont parfaits. J’ai une paire à votre taille, ne vous inquiétez pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le cordonnier se retira dans l’arrière-boutique et Sebastian soupira, souhaitant que l’homme ait utilisé un autre mot pour décrire ses pieds.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.93em"
    }
  }, [_vm._v("QUELQU’UN ME")]), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" suit. ")]), _vm._v("Une nouvelle fois, Sebastian prit un tournant et vit le même homme vêtu de brun du coin de l’œil. Alors qu’il passait les portes de Renan, une ville autrefois prospère grâce au travail du bois, il saisit son poignard et plongea derrière un buisson. La silhouette capée regarda d’un côté et de l’autre puis continua sur le chemin qu’avait emprunté Sebastian. Une fois l’étranger hors de vue, il retourna en direction des portes. Il se fondit dans le flot de personnes extérieures et chercha son ombre toutes les deux minutes. Au début, il ne vit aucun signe, mais la cape brune réapparut. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Mon stupide père devait avoir raison. Si je me fais tuer, je les maudirai, lui et le prince.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il ne voulait pas attirer l’attention des Gardes de la ville alors il se mêla à la foule. Il tourna dans des rues, des allées, se frayant un chemin vers les ateliers de menuiserie abandonnés. Une nouvelle fois à droite puis, il s’adossa à une porte. Il leva une main et une plante cachée sous les pavés grandit. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Arrête-le !")]), _vm._v(" pensa-t-il fortement, l’envoyant sur la route attendre l’étranger. Lorsque des bruits de pas légers se rapprochèrent, la plante fit trébucher son poursuivant. Sebastian sortit de sa cachette et enroula son bras autour du cou de l’homme, appuyant son couteau contre sa gorge.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pourquoi me suivez-vous ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pourquoi m’avez-vous abandonné dans une taverne ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian baissa son couteau et retourna l’homme. Devant lui se tenait le Prince Turren, ses cheveux noirs dégoulinants. Il regarda à la hâte les alentours puis éloigna le prince de lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Désolé, Votre Altesse, je vous ai pris pour un brigand. Passez une bonne soirée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il rengaina son couteau et jeta un œil dans l’allée pour voir s’il y avait des témoins. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Personne, semblerait-il")]), _vm._v(", soupira Sebastian. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Cet idiot n’a pas encore attiré l’attention sur moi. ")]), _vm._v("Il s’apprêtait à partir quand Turren se précipita devant lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Attendez ! Je vous ordonne d’attendre ! Laissez-moi au moins vous remercier.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne sais pas de quoi vous parlez. Son Altesse est-elle souffrante ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Excusez moi ? Vous êtes Sebastian Orwell.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Prince Turren tendit la main vers le coude de Sebastian, mais il échappa à sa prise.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Votre cape est plus étrange que dans mon souvenir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comme je vous l’ai dit, vous faites erreur. J’ai entendu parler des Orwell, vous pourrez les trouver dans la forêt du roi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian baissa la tête et feinta à droite, mais Turren bondit sur son chemin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je peux vous amener à la garde de la ville et leur ordonner d’ôter votre capuche.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lassé de l’insistance de Turren, Sebastian poussa sa paume dans le nez royal. Le prince bougea sa tête à temps, mais il avait à présent assez de place pour fuir. Il sprinta hors de l’allée et continua de courir jusqu’à ce que Renan soit une ombre à l’horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("SEBASTIAN SORTIT")]), _vm._v(" à nouveau sa longue-vue et repéra la cape brune. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Je pourrais pleurer")]), _vm._v(". "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Je pourrais véritablement pleurer")]), _vm._v(". De fausses pistes en chemins de chasse non utilisés, et le prince était toujours sur sa trace. Sebastian abandonna et construisit un petit feu dans les bois. Il déballa un poisson des feuilles ensorcelées qui conservaient sa fraîcheur et l’embrocha pour son dîner. Pendant que son dîner grillait, il fouilla son sac à la recherche d’une assiette et patienta. Rien ne bougea dans les arbres jusqu’à ce qu’il ne reste qu’un squelette de son repas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren se tenait de l’autre côté des flammes et se léchait les lèvres.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Serait-ce trop…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, le coupa Sebastian sans lever les yeux vers lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je voulais seulement savoir si vous en aviez davantage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Prince Turren s’assit sur l’herbe en face de lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il devrait être acceptable que je m’asseye.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian sortit une couverture de son sac.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous avez hérité de ce droit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous ne me traitez pas comme tel.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous obtiendrez tout mon soi-disant respect quand votre père sera mort et que vous deviendrez roi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren fronça les sourcils.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pouvons-nous ne pas parler de la mort de mon père ? Cela porte malheur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Évidemment, vous êtes du genre superstitieux, remarqua Sebastian. Je vais dormir. Restez de votre côté du feu.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pourquoi m’avez-vous sauvé ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne l’ai pas fait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren grogna, légèrement incrédule.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Peut-être que votre sauveur capé n’a pas aimé l’idée de laisser quelqu’un d’innocent mourir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Peut-être est-il quelqu’un de gentil.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian ricana.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Allez dormir, et ne ronflez pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("— QUE VEUX-TU")]), _vm._v(" dire par mon fils est parti ? demanda le Roi Harris.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il s’est enfui, Votre Majesté. Il a laissé un message disant qu’il devait régler une dette, expliqua Lord Pasley.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Capitaine Pembrost ! hurla le Roi Harris.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Également disparu. Quand je lui ai dit pour le Prince Turren, il a souri et répondu ‘je vais chasser deux lapins’.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il sait mieux que personne où est allé Turren. Envoie une escouade pour les suivre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Roi Harris secoua la tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Combien de temps mon fils peut-il rester sur ses pieds avec du poison dans l’organisme ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Pasley haussa les épaules.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Aisément un jour ou deux, s’il ne repousse pas ses limites.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Roi Harris soupira.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Les chances qu’il ne le fasse pas sont très minces.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("SEBASTIAN JETA")]), _vm._v(" un œil sur l’espace vide de l’autre côté du feu éteint. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Peut-être que le prince obstiné a-t-il compris l’allusion")]), _vm._v(" ? De doux ronflements derrière son oreille mirent fin à son espoir. Sebastian se retourna, Turren dormait paisiblement, plus près de là où il s’était retiré pour la nuit. Sebastian fit tambouriner ses doigts sur sa couverture. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Je souhaiterais que vous cessiez de me mettre dans des positions embarrassantes")]), _vm._v(". Renonçant à l’impulsion d’obstruer les narines du prince, il se leva prudemment et chercha son sac. Il l’aperçut de l’autre côté de Turren, son ouverture serrée entre les doigts de cet homme frustrant. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Ce serait bien fait pour lui si je lui déversais mon outre sur le visage")]), _vm._v(". Au lieu de cela, il se pencha et tira doucement sur la taie d’oreiller. La main de Turren traîna dans la poussière, ses doigts finissant par s’ouvrir. Sebastian leva son sac et puis une gorge se racla.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tout ce que tu avais à faire était de demander.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian fronça les sourcils vers le prince à présent réveillé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne devrais pas avoir à demander mes affaires.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren s’étira et bâilla.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’était une précaution au cas où tu aurais tenté de partir avant mon réveil.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment aurais-je pu laisser un charmeur comme vous ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian arracha son sac et commença à marcher.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Où allons-nous ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vais voir mon frère, dit Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— L’aîné des Orwell ? Il y a des années que je ne l’ai pas vu. Il nous a pourchassés, Pratchett et moi, durant des heures, raconta Turren en souriant. J’étais un sale gosse alors, mais ce sont des souvenirs plaisants.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous êtes toujours un sale gosse, dit Sebastian dans sa barbe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est vrai, mais je prends de meilleures décisions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian s’arrêta et se retourna.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous baguenaudez après un homme que vous n’avez pas vu depuis votre enfance. Vous voyagez sans aucun garde après une récente tentative d’assassinat. Expliquez-moi en quoi vous ne prenez pas de mauvaises décisions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren redressa ses épaules.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mon but quand je suis arrivé à la maison était de partir à ta recherche. À présent, je suis en ta compagnie depuis une journée. J’approche de mes objectifs plus rapidement que prévu, donc je suis assez satisfait de mes décisions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian croisa les bras.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quels objectifs ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il est dans mon intérêt de ne pas encore les révéler, dit le prince.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— À quel point votre magie est-elle puissante ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren cilla.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce fut un rapide changement de sujet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vos assaillants vous ont probablement pris par surprise, mais maintenant, vous êtes conscient du danger et vous pouvez vous protéger mieux qu’avant, c’est exact ? demanda Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne serai pas à nouveau une proie facile. Je ne comprends toujours pas où tu veux en venir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nulle part.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian fit à nouveau face à la route et commença à marcher d’un bon pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren lui attrapa l’épaule.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Que mijotes-tu ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian fusilla du regard la main qui n’aurait pas dû pouvoir se poser sur lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vois. Vous tenez de votre mère.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il la repoussa et continua de marcher.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous avez vos motivations, j’ai les miennes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.93em"
    }
  }, [_vm._v("— VOUS TESTEZ")]), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" la patience de mon cousin, Capitaine.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost tenait son amulette tout en buvant de l’autre main.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Je suis sur la trace du prince. De ce que je vois, il va bien et voyage en compagnie d’un autre homme")]), _vm._v(", envoya-t-il mentalement au mage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Vous croyez que c’est notre sauveur")]), _vm._v(", renvoya le Mage de la Cour.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Je ne pense pas qu’il soit coupable de l’agression, mais il sait probablement quelque chose. Sinon pourquoi s’enfuirait-il ?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Votre imprécision me donne des envies de malédictions.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Je suis désolé, Frederick, mais l’homme que je suspecte est le fils d’un seigneur agaçant. Il me faut des preuves solides avant de porter des accusations. Transmettez mes hommages au roi et ne me contactez pas durant un certain temps.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost relâcha son amulette et regarda le groupe de pisteurs se faisant passer pour des marchands de blé. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Et si je ne peux pas attraper le sauveur, peut-être pourrai-je attraper les assassins tentant un autre coup.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("LORD PASLEY")]), _vm._v(" soupira tandis que son cousin le foudroyait du regard.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il est sur la piste de Turren, il a un plan.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Roi Harris se pencha en arrière et se massa les tempes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pourquoi les personnes qui me sont les plus proches ne peuvent-elles pas agir comme si elles obéissaient à mes ordres ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Pasley se racla la gorge.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— D’accord, tu es obéissant, mais seulement, car tu n’as pas mon travail.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Pasley haussa les épaules.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’avoue que ne pas être l’héritier me rend beaucoup plus coopératif qu’un magicien lambda.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Connard, tu es censé nier et dire que tu es mon loyal serviteur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Roi Harris soupira.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Aucun de vous ne fait ce qu’il est supposé faire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— La Reine Anne ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Elle a rompu le contact il y a des heures. Je n’ai aucune idée d’où elle se trouve.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Pasley fronça les sourcils.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je me demande si elle ne pensait pas la même chose que Pembrost.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce qui serait bien si l’un d’eux décidait de partager leur réflexion avec moi !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Roi fit claquer son poing sur son accoudoir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Où est l’escouade que tu as envoyée après Pembrost ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Suffisamment près pour savoir qu’il est à l’extérieur de Bruwen, mais assez éloigné pour ne pas le perdre de vue. Je pense.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Roi Harris le congédia de la main.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e75ce9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0006.vue
// module id = 72
// module chunks = 0